$(function () {
    var auth = ycgame.auth;

    // 登录
    $(".lv1-tab input, .lv2-tab input, .lv3-content1-tab input, .lv3-content2-tab input").click(function (e) {
        $("#warming").fadeIn();
        // if (! auth.member) {
        //     $.ycUserDialogOpen();
        //     e.stopImmediatePropagation();
        // }
    });

    $(".hint-window-btn").click(function () {
        $(".hint-window-text").html("");
        $(".hint-window").hide();
    });

    auth.bind( auth.EVENTS.LOGOUT, function () {
        sessionStorage.removeItem('markId');
        sessionStorage.removeItem("id");
        sessionStorage.removeItem("regional");
        location.reload();
    });

    auth.checkLogin();

    auth.bind( auth.EVENTS.LOGIN, function () {
        role();
        $(".login").css("opacity",1);

        $(".lv1-tab input").attr('disabled', true).click(function () {
            $(this).addClass('active').siblings().removeClass('active');
            var indexId = $(this).index();
            $(".lv1-tab3-members-players").html("");
            role(indexId);

        });
        // 创建小分队
        $(".open-create-btn-confirm").click(function () {
            createATeam();
        });
        $(".open-create-btn-cancel").click(function () {
            $(".open-create").hide();
        });
        // 加入小分队
        $("input.lv1-tab2-content1-invite-code").blur(function () {
            var id = $("input.lv1-tab2-content1-invite-code").val();
            queryTeam(id);
        });
        $(".lv1-tab2-content2 a").click(function () {
            var id = $("input.lv1-tab2-content1-invite-code").val();
            joinTheTeam(id);
        });
        //离开队伍
        $(".lv1-tab3-members-delete li").click(function () {
            var index = $(this).index();
            var id = $(".lv1-tab3-members-players li").eq(index+1).attr("data-id");
            leaveTheTeam(id);
        });
        $(".lv1-tab3-members-exit a").click(function () {
            var id = $(this).attr("data-id");
            leaveTheTeam(id);
        });
        // 领取奖励
        $(".lv2-tab li input").click(function () {
            $(this).attr('disabled', true);
            var id = $(this).attr('data-id');
            cashRewards(id);
        });

        // 额外奖励
        $(".lv3-box input").click(function () {
            //获取当前时间
            var date = new Date();
            var now = date.getTime();

            //设置截止时间
            var str="2019/5/6 11:00:00";
            var endDate = new Date(str);
            var end = endDate.getTime();

            //时间差
            var leftTime = end-now;

            if (leftTime>0) {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("武将池、皮肤池兑换将于5月6日11：00开放，敬请期待！")
                });
            }else {
                $(this).attr('disabled', true);
                var id = $(this).attr('data-id');
                cashRewards(id);
            }

        });

        $(".open-notice-btn").click(function () {
            $(".open-notice").hide();
            $(".open-notice h3, .open-notice p").html("");
        });
        $(".hint-window-btn").click(function () {
            $(".hint-window-text").html("");
            $(".hint-window").hide();
        });

    });

    // 初始化获取用户信息
    function role(indexId) {
        var userDataUrl = 'http://act-api.bos.ycgame.com/new-spring-2019/team/players';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {

            $(".login-username i.login-username-id").html(data.character);
            var regional = sessionStorage.getItem("regional");
            if (regional) {
                $(".login-username i.login-regional").html(regional);
            } else {
                if (data.area == "ces3"){
                    $(".login-username i.login-regional").html("铁甲雄兵");
                } else if (data.area == "tj04") {
                    $(".login-username i.login-regional").html("兵临城下");
                }
            }

            $(".lv1-tab input").removeAttr('disabled');
            if (data.hasExchange.length != 0){
                $.each(data.hasExchange,function (index,value) {
                    if (value < 5){
                        $(".dataId" + value).attr("disabled", true).addClass('active');
                    } else if (value > 4 && value < 10){
                        $(".lv3-content1-tab input").attr("disabled", true).addClass('active').hide();
                        $(".dataId" + value).show();
                    } else if (value > 9){
                        $(".lv3-content2-tab input").attr("disabled", true).addClass('active').hide();
                        $(".dataId" + value).show();
                    }

                })
            }
            if (data.isInTeam){
                $(".lv1-tab, .lv1-tab input").hide();
                checkTheTeam();
                $(".lv1-tab3-content").show().siblings().hide();
            } else {
                $(".lv1-tab, .lv1-tab input").show();
                if (indexId == 0){
                    $(".lv1-box li").hide();
                    $(".open-create").show();
                } else if (indexId == 1){
                    $(".lv1-tab2-content").show().siblings().hide();
                } else if (indexId == 2){
                    $(".lv1-box li").hide();
                    $(".hint-window").show();
                    $(".hint-window-text").html("您尚未创建队伍或加入队伍！")
                }
                else {
                    $(".lv1-tab3-content").hide();
                }

            }

        }).fail(function (xhr) {
            $(".regional-user, .username-user").html("");
            var markId = sessionStorage.getItem('markId');
            if (xhr.responseJSON.code == "choose character") {
                userData();
            } else {
                alert("数据异常,请稍后再试！");
                return false;
            }

        })
    }


    // 获取当前账号所在大区信息
    function userData() {
        var userDataUrl = 'https://act-api.bos.ycgame.com/game/characters';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            var dataArr = data.data;
            openRegional();
            // 产生大区
            dataArr.forEach(function (item) {
                $(".regional-user").append("<p data-id=" + item.id + ">" + item.name + "</p>")
            });

            $(".lv1-tab input").removeAttr('disabled');

            $(".regional-user p").click(function () {

                var id = $(this).attr("data-id");

                dataArr.forEach(function (item) {

                    if (item.id == id && item.characters.length != 0) {
                        var dataArea = item.id;
                        $.each(item.characters, function (index, value) {
                            $(".username-user").append("<p data-id=" + value.dbid + " data-lv=" + value.level + " data-area="+ dataArea +">" + value.name + "</p>");
                        })
                    } else if (item.id == id && item.characters.length == 0) {
                        $(".username-user").append("<p style='color: red'>该区未创建角色！</p>");
                        setTimeout(function () {
                            $(".login-out").click();
                        },2000);
                    }
                });

            });

        }).fail(function (xhr) {
            alert("请求超时，请稍后再试！");
            $(".login-out").click();
            return false;
        })
    }

    // 确认绑定账户信息
    function electUser(id,area) {

        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/new-spring-2019/choose-character/all",
            data: {"dbid": id, "area": area},
            xhrFields: {
                withCredentials: true
            }
        }).done(function () {
            role();
        })
    }

    // 创建小分队
    function createATeam() {
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/new-spring-2019/team/create-team",
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".open-create").hide();
            $(".open-notice").show();
            $(".open-notice h3").html("创建战队成功！");
            $(".open-notice p").html("邀请好友加入战队，并肩战斗吧！");
            $(".lv1-tab, .lv1-tab input").hide().removeClass('active');
            checkTheTeam();
        }).fail(function (xhr) {
            if  (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您已加入战队！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            } else if (xhr.status == 401) {
                role();
            }
        })
    }

    // 加入小分队
    function joinTheTeam(id) {
        var url = "http://act-api.bos.ycgame.com/new-spring-2019/team/join-team";
        $.ajax({
            type: "POST",
            url: url,
            data:{code:id},
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".open-notice").show();
            $(".open-notice h3").html("加入战队成功！");
            $(".open-notice p").html("赶紧进入游戏完成任务领取奖励");
            $(".lv1-tab2-content").hide().siblings(".lv1-tab3-content").show();
            $(".lv1-tab, .lv1-tab input").hide().removeClass('active');
            checkTheTeam();
        }).fail(function (xhr) {
            if  (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您已加入战队！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "noTeam") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("邀请码对应的战队不存在！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "hasFull") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("该战队已满！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "differArea") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("请输入同战区的战队邀请码！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            } else if (xhr.status == 401) {
                role();
            }
        })
    }

    // 查询邀请码所属队伍
    function queryTeam(id) {
        var url = "http://act-api.bos.ycgame.com/new-spring-2019/team/name";
        $.ajax({
            type: "GET",
            url: url,
            data:{code:id},
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".lv1-tab2-content1-name i").html(data.code);
            if (data.code){
                $(".lv1-tab2-content1-name").show();
            }
        }).fail(function (xhr) {
            if  (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您已加入战队！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            } else if (xhr.status == 401) {
                role();
            }
        })
    }


    // 查看小分队
    function checkTheTeam() {
        var url = "http://act-api.bos.ycgame.com/new-spring-2019/team/members";
        $.ajax({
            type: "GET",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".lv1-tab3-content").show().siblings().hide();
            if (data.code){
                $(".lv1-tab3-captain-my-invite-code").show();
                $(".lv1-tab3-members-delete").show().siblings().hide();
            }else {
                $(".lv1-tab3-members-exit a").attr("data-id",data.dbid);
                $(".lv1-tab3-members-exit").show().siblings().hide();
            }

            $(".lv1-tab3-content-username").html(data.members[0].character);   //队长名
            if (data.area == "ces3"){
                $(".lv1-tab3-content-regional").html("铁甲雄兵");   //所在大区
            }else if (data.area == "wg1"){
                $(".lv1-tab3-content-regional").html("兵临城下");
            } else if (data.area == "tj02"){
                $(".lv1-tab3-content-regional").html("金戈铁马");
            } else if (data.area == "tj03"){
                $(".lv1-tab3-content-regional").html("烽火连天");
            }
            $(".lv1-tab3-captain-invite-code").html(data.code);   //邀请码

            data.members.forEach(function (item) {
                var membersList = '<li data-id='+ item.dbid +'><span class="lv1-tab3-members-name">'+ item.character +'</span><span class="lv1-tab3-members-level1">'+ item.level +'</span><span class="lv1-tab3-members-level2">'+ item.latestLevel +'</span><span class="lv1-tab3-members-level3">'+ item.rmLevName +'</span></li>';
                $(".lv1-tab3-members-players").append(membersList);
            });

            $(".lv1-tab3-members-level-sum").html(data.allAccuLevel);   //净增等级

        }).fail(function (xhr) {
            if (xhr.status == 403 && xhr.responseJSON.code == "noInTeam") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您尚未加入战队！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            } else if (xhr.status == 401) {
                role();
            }
        })
    }
    // 离开队伍
    function leaveTheTeam(dbid) {
        var url = "http://act-api.bos.ycgame.com/new-spring-2019/team/sign-out";
        $.ajax({
            type: "POST",
            url: url,
            data:{"dbid":dbid},
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".hint-window").fadeIn("fast", function () {
                $(".hint-window-text").html("退出成功！")
            });
            $(".lv1-tab3-members-players").html("");
            role();
        }).fail(function (xhr) {
            if (xhr.status == 403 && xhr.responseJSON.code == "noInTeam") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您尚未加入战队！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "false") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("成员连续48小时未登录游戏参与战斗，队长可剔除该成员；队长连续48小时未登录游戏参与战斗，队员可自行退出小队！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.code == "tomorrow") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("操作过于频繁，请明日再试！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            } else if (xhr.status == 401) {
                role();
            }
        })
    }
    // 兑换奖励
    function cashRewards(id) {
        var url = "http://act-api.bos.ycgame.com/new-spring-2019/team/exchanges/" + id;
        $.ajax({
            type: "POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".lv1-tab3-members-players").html("");
            $(".dataId" + id).attr("disabled", true).addClass('active');
            $(".open-notice").show();
            $(".open-notice h3").html("奖励领取成功！");
            $(".open-notice p").html("登录游戏查看邮件查收");
            role();
        }).fail(function (xhr) {
            $(".dataId" + id).removeAttr('disabled');
            if (xhr.status == 403 && xhr.responseJSON.code == "noInTeam") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("您尚未加入战队！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("该奖励已经领取过了！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.code == "lessAccuLevel") {
                if (id < 5){
                    $(".hint-window").fadeIn("fast", function () {
                        $(".hint-window-text").html("全员净增等级不足，无法领取奖励！")
                    })
                } else {
                    $(".hint-window").fadeIn("fast", function () {
                        $(".hint-window-text").html("请完成相应的任务后，再领取奖励！")
                    })
                }
            }else if (xhr.status == 403 && xhr.responseJSON.code == "lessLevel") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("个人等级不足20级或小队净增等级不满足条件，无法领取奖励！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.code == "lessMembers") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("尚未达成目标任务，无法领取奖励！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.code == "lessRmLevel") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("队友爵位等级不足，无法领取奖励！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.code == "false") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("操作失败，请稍后再试！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "兑换异常，请联系客服！") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("兑换异常，请稍后再试！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "服务器繁忙，请稍后再试！") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("兑换异常，请稍后再试！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            } else if (xhr.status == 401) {
                role();
            }
        })
    }



    // 大区选择
    var $regional;
    $regional = $('.regional');
    $regional.on('click', '.regional-user p', function () {
        closeRegional();
        openUser();
        sessionStorage.setItem("regional",$(this).html());
        $(".login-username i.login-regional").html($(this).html());
    });

    function openRegional(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $regional, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });

        $regional.data('layer', layerId);
        $regional.find('.' + id).show().siblings().hide();

        cb && cb.call($regional);
    }

    function closeRegional() {
        layer.close($regional.data('layer'));
    }

    // 角色选择
    var $user;
    $user = $('.username');
    $user.on('click', '.username-user p', function () {
        closeUser();


        $(".login-username i.login-username-id").html($(this).html());
        var dbid = $(this).attr("data-id");
        var area = $(this).attr("data-area");
        electUser(dbid,area);
        sessionStorage.setItem('id',dbid);
        sessionStorage.setItem('markId', $(this).html());
    });

    function openUser(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $user, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });

        $user.data('layer', layerId);
        $user.find('.' + id).show().siblings().hide();

        cb && cb.call($user);
    }

    function closeUser() {
        layer.close($user.data('layer'));
    }

});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0